import React from "react";
import { Modal } from "antd";
import RegisterForm from "../RegisterBlock";//

interface RegisterModalProps {
    isModalVisible: boolean;
    handleCancel: () => void;
}

const RegisterModal: React.FC<RegisterModalProps> = ({ isModalVisible, handleCancel }) => {
    return (
        <Modal
            title="Register"
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose={true}
        >
            <RegisterForm handleCancel={handleCancel} />
        </Modal>
    );
};

export default RegisterModal;